import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  companyID: "",
  companyName: "",
  companyURL: "",
  companyLogo: "",
  brandId: "",
  isIdentified: false,
};

const company = createSlice({
  name: "company",
  initialState,
  reducers: {
    setCompany: (state, action) => {
      return { ...state, ...action.payload};
    },
    clearCompany: () => {
      return initialState;
    }
  }
});

export const { setCompany, clearCompany } = company.actions;
export default company.reducer;
